module.exports = __webpack_public_path__ + "static/media/7-rectangle-occupied.3095cae6.svg";